module cr.entity {
    entityModule.directive('myCurrentTime', ['$interval', 'dateFilter', function ($interval, dateFilter) {

        function link(scope, element, attrs) {
            console.log("zen");
            var format,
                timeoutId;

            function updateTime() {
                element.text(dateFilter(new Date(), "h:mm:ss"));
            }

            scope.$watch(attrs.myCurrentTime, function (value) {
                format = value;
                updateTime();
            });

            element.on('$destroy', function () {
                $interval.cancel(timeoutId);
                console.log("destroy");
            });

            // start the UI update process; save the timeoutId for canceling
            timeoutId = $interval(function () {
                updateTime(); // update DOM
            }, 1000);
        }

        return {
            link: link,
            restrict: 'AE'
        };
    }]);

}